import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

export const calculateChange = (transaction: CartResponse): number => {
  const { useRefundToCalculateChange } = getCurrentXLRConfig();
  let change = 0;
  if (useRefundToCalculateChange) {
    change = transaction.refunds?.reduce((a, payment) => a + (payment.amount ?? 0), 0) ?? 0;
  } else {
    if (transaction.refunds?.length) {
      change = transaction.refunds.reduce((a, refund) => a + (refund.amount ?? 0), 0);
    } else if (transaction.payments?.length) {
      change = transaction.payments?.reduce(
        (a, payment) => a + (payment.cashBackAmount ?? payment.change ?? 0),
        0,
      );
    }
  }
  return change;
};
